(function () {
    'use strict';

    angular.module("imApp").factory("customerBusCosService", ['$ihttp', function ($ihttp) {
        let service = {
            getCustomerBusCos: function (parms) {
                return $ihttp.post({
                    method: 1294,
                    parameters: parms || {}
                });
            },
            listCustomerCompanies: function (parms) {
                return $ihttp.post({
                    method: 1292,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
